import GroupPerformance from './GroupPerformance';

export default GroupPerformance;
